import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import DetailForm from "./DetailForm";
import toast from "react-hot-toast";
import CooperativeService from "../../../services/CooperativeService";
import CoopteamService from "../../../services/COOPServices/CoopteamService";
import DeleteModal from "../Document/DeleteDocument";
import MyDocument from "./PdfDetail";
import { pdf } from "@react-pdf/renderer";
import LanguageToggle from "../Report/LanguageToggleButton/LanguageToggle";

const Detail = () => {
  const [facebookLink, setFacebookLink] = useState("https://facebook.com");
  const [twitterLink, setTwitterLink] = useState("https://twitter.com");
  const user = JSON.parse(localStorage.getItem("user"));
  const userImage = user?.user?.image;
  const coopId = user?.user?.cooperative_id;
  const userImageExtension = user?.user?.imageExtension;
  const imageSrc = userImageExtension
    ? `data:image/${userImageExtension.replace(".", "")};base64,${userImage}`
    : "No Image";
  const [coopList, setCoopList] = useState([]);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [coopteamId, setCoopteamId] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    document.title = "SCOOP Digital Cooperative System";
    fetchCooperativeDetails();
  }, [coopId]);

  const fetchCooperativeDetails = async () => {
    try {
      const response = await CooperativeService.getById(coopId);
      setCoopList(response || []);
    } catch (error) {
      console.error("Error fetching cooperative details:", error);
      toast.error("Failed to fetch cooperative details.");
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const toggleDelete = () => {
    setIsDeleteOpen(!isDeleteOpen);
  };

  const handleDelete = async () => {
    if (coopteamId) {
      try {
        await CoopteamService.delete(coopteamId);
        toast.success("Document Removed Successfully!");
        toggleDelete();
        fetchCooperativeDetails();
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("Failed to delete document.");
      }
    }
  };

  const handleDeleteTeam = (id) => {
    setCoopteamId(id);
    toggleDelete();
  };

  const handleGenerate = async () => {
    try {
      const pdfBlob = await pdf(
        <MyDocument coopList={coopList} imageSrc={imageSrc} />
      ).toBlob();
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div
              className="profile profile-setting-img border w-100"
              style={{ backgroundColor: "#E6E6EB" }}
            ></div>
          </div>
          <Row>
            <Col lg={4}>
              <div className="mt-n5">
                <div>
                  <div className="text-center d-flex">
                    <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit"></div>
                    </div>
                    <img
                      src={imageSrc}
                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                      alt="user-profile"
                    />
                    <div className=" pt-5">
                      <div>
                        {!isVisible ? (
                          <h6
                            className="text-start fs-16"
                            style={{ color: "green", marginBottom: "2px" }}
                          >
                            {coopList?.nameEng || "Co-operative Society"}{" "}
                            {/* samuhik bachat tatha rin sahakari sanstha ltd. */}
                          </h6>
                        ) : (
                          <h6
                            className="text-start fs-16"
                            style={{
                              color: "green",
                              textDecoration: "underline",
                              marginBottom: "0",
                            }}
                          >
                            {/* सामुहिक बचत तथा ऋण सहकारी संस्था लि. */}
                            {coopList?.nameNep || "Co-operative Society"}{" "}
                          </h6>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!isVisible ? (
                <Card>
                  <CardBody>
                    <h5 className="card-title fw-bold fs-16 border-bottom">
                      Information
                    </h5>
                    <div className="table-responsive">
                      <Table className="table-borderless mb-0">
                        <tbody>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              Phone No :
                            </th>
                            <td>{coopList?.phoneNumberEng || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              Email Address :
                            </th>
                            <td>{coopList?.email || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              Address :
                            </th>
                            <td>{coopList?.addressEng || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              Websites :
                            </th>
                            <td>{coopList?.website || "N/A"}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <Card>
                  <CardBody>
                    <h5 className="card-title fw-bold fs-16 border-bottom">
                      आधारभूत जानकारी
                    </h5>
                    <div className="table-responsive">
                      <Table className="table-borderless mb-0">
                        <tbody>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              फोन नम्बर :
                            </th>
                            <td>{coopList?.phoneNumberNep || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              इ - मेल ठेगाना :
                            </th>
                            <td>{coopList?.email || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              ठेगाना :
                            </th>
                            <td>{coopList?.addressNep || "N/A"}</td>
                          </tr>
                          <tr>
                            <th className="ps-0 text-muted" scope="row">
                              Websites :
                            </th>
                            <td>{coopList?.website || "N/A"}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              )}

              <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">Social Media Links</h5>
                    </div>
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <h2>
                        <i className="ri-facebook-box-fill text-secondary"></i>
                      </h2>
                    </div>
                    <Input
                      type="text"
                      className="form-control clickable-input text-color-primary"
                      placeholder="Facebook Link"
                      value={facebookLink}
                      onChange={(e) => setFacebookLink(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <h2>
                        <i className="ri-twitter-fill text-info"></i>
                      </h2>
                    </div>
                    <Input
                      type="text"
                      className="form-control clickable-input text-color-primary"
                      placeholder="Twitter Link"
                      value={twitterLink}
                      onChange={(e) => setTwitterLink(e.target.value)}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={8} className="pt-2 mt-2">
              <div className="d-flex gap-3 justify-content-end mb-3">
                    <button
                      style={{ border: "none", margin: "0", padding: "0" }}
                    >
                      <LanguageToggle
                        toggleVisibility={toggleVisibility}
                        setIsVisible={setIsVisible}
                        isVisible={isVisible}
                      />
                    </button>
                <Button
                  type="button"
                  className="btn btn-success"
                  onClick={handleGenerate}
                >
                  Generate Pdf
                </Button>
              </div>
              <Card>
                <h5 className="card-title pt-3 mx-4 fs-16 fw-bold border-bottom">
                  Introduction
                </h5>
                <p className="mx-4 fs-14">
                  {coopList?.introduction || "No introduction available."}
                </p>
              </Card>
              <Card>
                {!isVisible ? (
                  <h5 className="card-title mb-3 pt-3 mx-4 fs-16 fw-bold border-bottom">
                    Executive Committee
                  </h5>
                ) : (
                  <h5 className="card-title mb-3 pt-3 mx-4 fs-16 fw-bold border-bottom">
                    कार्यकारिणी समिति
                  </h5>
                )}

                <Row style={{ marginRight: "30px" }}>
                  {coopList?.executiveCommittee?.map((item, index) => (
                    <Col lg={4} className="gap-2 mb-3" key={item.id}>
                      <Card
                        style={{
                          width: "210px",
                          height: "240px",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className="mx-4"
                      >
                        <div
                          className="w-100"
                          style={{
                            maxWidth: "240px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            maxHeight: "140px",
                            minHeight: "140px",
                          }}
                        >
                          <img
                            src={`data:image/jpeg;base64,${item.image}`}
                            style={{ maxWidth: "150px", maxHeight: "150px" }}
                            alt="Avatar"
                          />
                        </div>

                        <h5 className="text-center  pt-2">{item.name}</h5>
                        <h6 className="text-center  ">{item.designation}</h6>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card>
              <Card>
                {!isVisible ? (
                  <h5 className="card-title mb-3 pt-3 mx-4 fs-16 fw-bold border-bottom">
                    Lekha Suparibechan Committee
                  </h5>
                ) : (
                  <h5 className="card-title mb-3 pt-3 mx-4 fs-16 fw-bold border-bottom">
                    लेखा सुपरिवेचन समिति
                  </h5>
                )}

                <Row style={{ marginRight: "30px" }}>
                  {coopList?.lekhaSuparibechanCommittee?.map((item, index) => (
                    <Col lg={4} className="gap-2 mb-3" key={item.id}>
                      <Card
                        style={{
                          width: "210px",
                          height: "240px",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className="mx-4"
                      >
                        <div
                          className="w-100"
                          style={{
                            maxWidth: "240px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            maxHeight: "140px",
                            minHeight: "140px",
                          }}
                        >
                          <img
                            src={`data:image/jpeg;base64,${item.image}`}
                            style={{ maxWidth: "150px", maxHeight: "150px" }}
                            alt="Avatar"
                          />
                        </div>
                        <h5 className="text-center  pt-2">{item.name}</h5>
                        <h6 className="text-center pt-1">{item.designation}</h6>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card>
              <DetailForm />
              <DeleteModal
                deleteTerm={"team member"}
                handleDelete={handleDelete}
                isOpen={isDeleteOpen}
                toggle={toggleDelete}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Detail;
